const Search = () => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('search', () => ({
      open: false,
      query: '',
      viewMoreURL: false,
      abortController: null,
      loading: false,
      results: [],
      get signal() {
        return this.abortController.signal;
      },
      overlayOpen(e) {
        if (e.detail.overlay !== 'search') {
          this.close();
        }
      },
      init() {
        this.abortController = new AbortController();
      },
      search() {
        if (!this.query) {
          this.results = [];
          this.viewMoreURL = false;

          return;
        }

        if (this.abortController) {
          this.abortController.abort();

          this.abortController = new AbortController();
        }

        this.loading = true;

        fetch(`${window.Shopify.routes.root}search/suggest.json?q=${this.query}`, {
          signal: this.signal,
        })
          .then((response) => response.json())
          .then((data) => {
            this.results = data.resources.results.products;
            console.log(data);
            if (data.resources.results.queries.length > 0) {
              this.viewMoreURL = data.resources.results.queries[0].url;
            } else {
              this.viewMoreURL = false;
            }
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              return;
            }

            console.error(error);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      close() {
        this.open = false;
        this.$dispatch('overlay:close', { overlay: 'search' });
        this.$dispatch('scroll:unlock', { element: this.$refs.searchScroll });
      },
      toggleSearch() {
        this.open = !this.open;

        if (this.open) {
          this.$refs.input.focus();
          this.$dispatch('overlay:open', { overlay: 'search' });
          this.$dispatch('scroll:lock', { element: this.$refs.searchScroll });
        } else {
          this.$dispatch('overlay:close', { overlay: 'search' });
          this.$dispatch('scroll:unlock', { element: this.$refs.searchScroll });
        }
      },
    }));
  });
};

export default Search;
